export default async () => {
  window.AdapterJS = window.AdapterJS || {}
  window.AdapterJS.options = window.AdapterJS.options || {}
  window.AdapterJS.options.hidePluginInstallPrompt = true

  if (process.env.NODE_ENV === "production") {
    await import("adapterjs");
  } else {
    await import("adapterjs/publish/adapter.debug.js");
  }
}
